import { createClient } from "@supabase/supabase-js";
import type { RuntimeConfig } from "./runtime";

const CORRELATION_KEY = "rs-career-erp-correlation-id";

function correlationId(): string {
  const stored = window.sessionStorage.getItem(CORRELATION_KEY);
  if (stored) return stored;

  const created = crypto.randomUUID();
  window.sessionStorage.setItem(CORRELATION_KEY, created);
  return created;
}

export function createPlatformClient(config: RuntimeConfig) {
  return createClient(config.supabaseUrl, config.supabasePublishableKey, {
    db: { schema: "api" },
    auth: {
      flowType: "pkce",
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true
    },
    global: {
      headers: {
        "x-correlation-id": correlationId()
      }
    }
  });
}

export type PlatformClient = ReturnType<typeof createPlatformClient>;
